import { render, staticRenderFns } from "./tab-postes-a-verser.vue?vue&type=template&id=0061d2ca&scoped=true"
import script from "./tab-postes-a-verser.vue?vue&type=script&setup=true&lang=js"
export * from "./tab-postes-a-verser.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0061d2ca",
  null
  
)

export default component.exports